import React from 'react'
import {Formik, Form} from 'formik'

import {
    Button, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, Grid,
    IconButton, makeStyles, Table, TableBody, TableRow, TableCell, TableContainer, TableHead
} from '@material-ui/core'
import {Close} from "@material-ui/icons"
import {useDispatch} from "react-redux"
import {standard} from "../../App/helpers/standard";
import * as Yup from "yup";
import {ItemActions} from "../actions/item";

const useStyles = makeStyles(theme => ({
    dialog: {
        'border-radius': 0
    },
    fullWidth: {
        'width': '100%'
    },
    primary: {
        'color': 'primary'
    },
    error: {
        'color': '#f44336'
    }
}))

const columns = [
    {id: 1, label: 'Эталон'},
    {id: 2, label: ''},
]

export const UnunionForm = (props) => {
    const dispatch = useDispatch()
    const classes = useStyles()

    const { handleClose, handleDelete, open, items, categories } = props

    return (
        <Formik
            enableReinitialize={ true }
            initialValues = {{
                items: items.map(item => ({
                    id: item.id,
                    name: standard(categories.find(cat => item.category.id === cat.id), categories, item.values)
                }))
            }}
            validationSchema={Yup.object().shape({
                items: Yup.array().of(Yup.object().shape({
                    id: Yup.number().required("Поле не может быть пустым или состоять из одних пробелов!"),
                    name: Yup.string()
                }))
            })}
            onSubmit = {(values, { setSubmitting }) => {
                return Promise.all(values.items.map(item => dispatch(ItemActions.ununion(item.id)))).then(
                    () => {
                        setSubmitting(false)
                        handleClose(true)
                    },
                    errors => {
                        if (errors) { }
                        setSubmitting(false)
                    }
                )
            }}
        >
            {({
                values,
                handleSubmit,
                isSubmitting
            }) => (
                <Form>
                    <Dialog
                        fullWidth={ true }
                        maxWidth="md"
                        open={ open }
                        onClose={ handleClose }
                        aria-labelledby="Отмена объединения эталонов"
                        classes={{
                            paper: classes.dialog
                        }}
                    >
                        <DialogTitle>Отмена объединения эталонов</DialogTitle>
                        <DialogContent>
                            <Grid container direction='column' justify='center' alignItems='center' spacing={2}>
                                <Grid item sm={10} className={classes.fullWidth}>
                                    <TableContainer>
                                        <Table stickyHeader aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    {columns.map(column => (
                                                        <TableCell
                                                            key={column.id}
                                                        >
                                                            {column.label}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {values.items.map(item => (
                                                    <TableRow key={item.id} >
                                                        <TableCell align="left" style={{ whiteSpace: 'normal' }}>
                                                            {item.name}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <IconButton
                                                                aria-label="Удалить"
                                                                disabled={ isSubmitting }
                                                                onClick={() => handleDelete(item.id) }
                                                            >
                                                                <Close />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <DialogActions>
                                <Button
                                    disabled={ isSubmitting }
                                    onClick={ handleClose }
                                    color="secondary"
                                    type="submit"
                                >
                                    Отмена
                                </Button>
                                <Button
                                    disabled={ isSubmitting || (items.length < 1) }
                                    onClick={ handleSubmit }
                                    color="primary"
                                    type="submit"
                                >
                                    { isSubmitting ? <CircularProgress size={24} /> : 'Сохранить' }
                                </Button>
                            </DialogActions>
                        </DialogActions>
                    </Dialog>
                </Form>
            )}
        </Formik>
    )
}
